export default {
  SET_PEOPLE (state, people) {
    state.people = people
  },
  SET_PERSON (state, person) {
    state.person = person
  },
  SET_ADDRESSES (state, addresses) {
    state.addresses = addresses
  },
  UPDATE_ADDRESS (state, address) {
    // REMOVE OLD ADDRESS
    const ItemIndex = state.addresses.findIndex((p) => p.id === address.id)
    state.addresses.splice(ItemIndex, 1)
    // ADD NEW ADDRESS
    state.addresses.unshift(address)
  },
  CREATE_ADDRESS (state, address) {
    state.addresses.unshift(address)
  },

  UPDATE_USERS (state, person) {
    const userIndex = state.users.findIndex((p) => p.id === person.id)
    Object.assign(state.users[userIndex], person)
  },
  CREATE_PERSON (state, person) {
    state.person = person
  },
  REMOVE_ADDRESS (state, addressId) {
    const ItemIndex = state.addresses.findIndex((p) => p.id === addressId)
    state.addresses.splice(ItemIndex, 1)
  }
}
